import React from 'react';
import { Menu, Box, Typography, Button, Stack, useTheme, MenuItem } from '@mui/material';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { ProductMode } from '@domain/product/models/ProductMode';
import CheckIcon from '@mui/icons-material/Check';
import { CheckCircle, CheckCircleOutline } from '@mui/icons-material';
const menuAnchorProps = {
  anchorOrigin: { vertical: 'bottom' as const, horizontal: 'right' as const },
  transformOrigin: { vertical: 'top' as const, horizontal: 'right' as const },
};

const modeOptions = [
  { value: ProductMode.REVENUE_OPTIMIZED, label: 'Revenue optimized', icon: '/assets/icons/ic_importance_high.svg' },
  { value: ProductMode.BALANCED, label: 'Balanced', icon: '/assets/icons/ic_importance_medium.svg' },
  { value: ProductMode.COST_OPTIMIZED, label: 'Cost optimized', icon: '/assets/icons/ic_importance_low.svg' },
];

interface BulkEditModeDropdownProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  value: ProductMode | undefined;
  onChange: (value: ProductMode) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const BulkEditModeDropdown: React.FC<BulkEditModeDropdownProps> = ({
  anchorEl,
  open,
  onClose,
  value,
  onChange,
  onConfirm,
  isLoading = false,
}) => {
  const theme = useTheme();

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose} {...menuAnchorProps}>
      <Box sx={{ p: 0, width: 320 }}>
        <DialogHeader>
          <Typography variant="subtitle2">Mode</Typography>
        </DialogHeader>

        <Stack direction="column">
          {modeOptions.map((option) => (
            <MenuItem

              key={option.value}
              onClick={() => onChange(option.value as ProductMode)}
              selected={value === option.value}
              disabled={isLoading}
              sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2, px: 3 }}
            >
              {option.icon && (
                <img src={option.icon} alt={option.label} width={16} height={16} />
              )}
              <Typography flex={1} variant="body2">{option.label}</Typography>

              {value === option.value && (
                <CheckCircleOutline fontSize="small" color="primary" />
              )}
            </MenuItem>
          ))}
        </Stack>

        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="space-between"
          flex={1}
          sx={{ p: 2, borderTop: 1, borderColor: theme.palette.divider }}
        >
          <Button variant="text" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} disabled={isLoading || value === undefined}>
            {isLoading ? 'Saving...' : 'Apply'}
          </Button>
        </Stack>
      </Box>
    </Menu>
  );
};

export default BulkEditModeDropdown;
